import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  drawerMenu: {
    paddingTop: theme.spacing(2),
    width: 280,
    minHeight: '100%',
    overflow: 'auto',
  },
  title: {
    display: 'flex',
    paddingLeft: theme.spacing(2),
    marginBottom: theme.spacing(2),
    whiteSpace: 'nowrap',
  },
  appBarTitle: {
    color: 'white',
    padding: theme.spacing(0, 2),
    marginBottom: 0,
  },
  icon: { marginRight: theme.spacing(2), height: '32px', width: '32px' },
}));
